// extracted by mini-css-extract-plugin
module.exports = {"intro":"Show-module__intro___VH29l","text":"Show-module__text___2h3-L","date":"Show-module__date___3kaeZ","docs":"Show-module__docs___qGsxe"};